import type { PublicStore } from "@/types/models";

export interface StoreHeaderProps {
  store: PublicStore;
}

export default function StoreHeader({ store }: StoreHeaderProps) {
  const accentStyle = store.primaryColor
    ? { borderBottomColor: store.primaryColor }
    : undefined;

  const logoSrc = store.logoUrl ?? store.logoThumbnailUrl;

  return (
    <header
      className="mb-6 pb-4 border-b border-primary-200 dark:border-primary-800 md:mb-10 md:pb-6"
      style={accentStyle}
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-6 mb-4">
        {logoSrc && (
          <img
            src={logoSrc}
            alt={`Logo de ${store.name}`}
            className="h-16 w-16 object-contain shrink-0"
            data-testid="storefront-logo"
          />
        )}
        <h1
          className="text-3xl font-light tracking-tight text-primary-900 dark:text-white md:text-4xl"
          style={store.primaryColor ? { color: store.primaryColor } : undefined}
        >
          {store.name}
        </h1>
      </div>
      {store.description && (
        <p className="mt-3 text-base font-light text-primary-600 dark:text-primary-400 max-w-2xl">
          {store.description}
        </p>
      )}
    </header>
  );
}
